import { Inject, Injectable } from '@angular/core';
import { PLATFORM_API_URL } from '@core/constants';
import { UserCredentials } from '../model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PlatformHttpService {
  constructor(
    private readonly http: HttpClient,
    @Inject(PLATFORM_API_URL) private readonly platformApiUrl: string,
  ) {}

  getUserProfileCredentialsByEmails(emails: string[]): Observable<UserCredentials[]> {
    return this.http.post<UserCredentials[]>(`${this.platformApiUrl}/api/Graph/GetUserProfilesListCredentialsByEmails`, emails);
  }
}
